import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import moment from "moment";

import "./editor-tracking-metadata.scss";
import {ItemType} from "../../../models/item-type";


export interface EditorTrackingMetadataProps {
    editableItem: ItemType;
}

@observer
export class EditorTrackingMetadata extends Component<EditorTrackingMetadataProps, any> {

    constructor(props: EditorTrackingMetadataProps) {
        super(props);
        this.state = {};
    }


    render(): React.ReactElement | null {
        const {editableItem} = this.props;

        if (!editableItem) {
            return null;
        }

        let createdAtText: string | null = "";
        if (editableItem.creator) {
            const creator = editableItem.creator;
            const createdAt = moment(editableItem.createdAt).format("DD.MM.YYYY");
            createdAtText = `${editableItem.typeLabel} erstellt von ${creator} am ${createdAt}.`;
        }
        let updatedAtText: string | null = "";
        if (editableItem.editor) {
            const editor = editableItem.editor;
            const updatedAt = moment(editableItem.updatedAt).format("DD.MM.YYYY");
            updatedAtText = `${editableItem.typeLabel} zuletzt geändert von ${editor} am ${updatedAt}.`;
        }

        return (
            <div className="editor-metadata">
                <span className="editor-metadata-creator">{createdAtText}</span>
                <span className="editor-metadata-editor">{updatedAtText}</span>
            </div>
        );
    }

}
